// Check Assignment Balance
export const CHECK_ASSIGNMENT_BALANCE_REQUEST = 'CHECK_ASSIGNMENT_BALANCE_REQUEST';
export const CHECK_ASSIGNMENT_BALANCE_DONE = 'CHECK_ASSIGNMENT_BALANCE_DONE';
export const CHECK_ASSIGNMENT_BALANCE_FAILED = 'CHECK_ASSIGNMENT_BALANCE_FAILED';
export const CHECK_ASSIGNMENT_BALANCE_CLEAR_ERRORS = 'CHECK_ASSIGNMENT_BALANCE_CLEAR_ERRORS';
export const CHECK_ASSIGNMENT_BALANCE_RESET = 'CHECK_ASSIGNMENT_BALANCE_RESET';